import { render, staticRenderFns } from "./AssetChartsSettings.vue?vue&type=template&id=7ded73c6&scoped=true&"
import script from "./AssetChartsSettings.vue?vue&type=script&lang=js&"
export * from "./AssetChartsSettings.vue?vue&type=script&lang=js&"
import style0 from "./AssetChartsSettings.vue?vue&type=style&index=0&id=7ded73c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ded73c6",
  null
  
)

/* custom blocks */
import block0 from "./AssetChartsSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports